import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./confirmation.css"; // Ensure this file includes the styles above or import a dedicated confirmation CSS file

const OrderConfirmation = () => {
    const location = useLocation();
    const { orderId, totalPrice} = location.state || {};

    return (
        <div className="confirmation-container">
            <Header />
            <div className="confirmation-wrapper">
                <div className="confirmation-content">
                    <h1>Gracias por su orden!</h1>
                    <p>Su orden se ha procesado con éxito. Desde este momento puede realizar la recolección del kit</p>
                    <p>
                        <strong>Identificador</strong> {orderId}
                    </p>
                    <p>
                        <strong>Total: </strong> ₡{totalPrice} colones
                    </p>
                    <p>
                        Puede retirar la orden con su nombre,  número de carné o número de órden
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default OrderConfirmation;